<template>
  <section class="content--sinoreg">
    <header class="headerBlue">
      <span class="pt-3 resumo-show_title-label">
        Pagamentos de Serviços Faturados
      </span>
    </header>
    <div>
      <OrdemServicoMensalista @addMensalista="setMensalista" />
      <FiltroDataMensalista class="ml-3 mb-4"
                            :prop-id-mensalista="mensalistaId"
                            @getServicosRealizados="getPerdidosMensalista" />
      <div class="table">
        <TablePendentes :prop-mensalista="mensalista"
                        :prop-filtro-mensalista="filtroMensalista"
                        @listaPagamento="handlerListaPagamento" />
      </div>    
    </div>
    <ReceberPagamentosFaturados :prop-mensalista="mensalista"
                                :prop-lista-pagamento="listaPagamento"
                                @atulizarTabela="atualizarPedidosMensalista" />
  </section>
</template>

<script>
  // Components
  import TablePendentes from '../../FrenteDeCaixaPendentes/TablePendentes.vue'
  import OrdemServicoMensalista from '../OrdemServicoMensalista/OrdemServicoMensalista.vue'
  import FiltroDataMensalista from '../Filtros/FiltroDataMensalista.vue'
  import ReceberPagamentosFaturados from './ReceberPagamentosFaturados/ReceberPagamentosFaturados.vue'

  // vuex
  import { mapState } from 'vuex'

  // Services
  import MensalistaService from '../mensalistaService'

  export default ({
    name: 'PagamentosFatutados',
    components: { 
      TablePendentes,
      OrdemServicoMensalista,
      FiltroDataMensalista,
      ReceberPagamentosFaturados
    },
    data () {
      return {
        mensalistaId: null,
        mensalista: null,
        listaPagamento: null,
        filtroMensalista: null
      }
    },
    computed: mapState(['frenteCaixa']),
    methods: {
      setMensalista (mensalista) {
        this.mensalistaId = mensalista
      },
      getPerdidosMensalista (mensalista, filtroPayload) {
        // Zera a lista de pagamentos para evitar que se gere pagamentos de mais de 1 mensalista por vez
        this.listaPagamento = []
        // Adiciona um proprieda aos pedidos para check
        mensalista[0].pedidos.forEach(item => {
          item.check_pendentes = false
          item.valorTotal = item.ordemServico ? item.ordemServico.valor_total :
            item.lancamentosAvulso ? item.lancamentosAvulso.valor_total : ''
        })
        if (!mensalista[0].pedidos.length) {
          return displayMessage('error', '', 'Não existem pedidos desse menslista no período selecionado!')
        }
        this.mensalista = mensalista[0].pedidos
        this.filtroMensalista = filtroPayload
      },
      handlerListaPagamento (lista) {
        this.listaPagamento = lista
      },
      async atualizarPedidosMensalista () {
        // Ao zezar mensalista automaticamente será feito um novo fetch à partir dpo proprio componente "TabelaPendentes"
        this.mensalista = []
      }
    },
  })
</script>

<style lang="scss" scoped>
  @import "../../../../../scss/_utilities/_variables";

  section {
    position: relative;
    padding-bottom: 55px;
      .headerBlue{
      background-color: $sinoreg-blue;
      color: $color-white;
      fill: $color-white;
      padding: pxToRem(8);
      font-size: pxToRem(20);
      font-weight: 500;
      height: 100%;
      width: 100%;
    }
    .table {
      margin-left: 20px;
      width: 96%;
    }    
  }

</style>
